/**
 * Browser CSV download from an array of row objects (shared by trade book, position report, etc.).
 */

export function downloadCsvFromObjects(rows, fileName) {
  if (!rows || rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const body = rows.map((row) =>
    headers.map((h) => {
      const v = row[h] == null ? "" : String(row[h]);
      return v.includes(",") ? `"${v}"` : v;
    }).join(",")
  );
  const csv = [headers.join(","), ...body].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
